import { LocationStringMap } from '../../../util/index';
import { Http, Resource } from '../../models/index';
import { DebounceUseCase } from '../DebounceUseCase';
import { RequestResource } from './RequestResource';

export namespace GetResourceWithBody {
    export interface Params<L extends string> {
        parent: Resource<L>;
        rel: L;
        search?: LocationStringMap;
        noLinkError?: boolean;
        queryParams?: object;
        useCache?: boolean;
        body: any;
    }
}

export class GetResourceWithBody<L extends string, T> extends DebounceUseCase<
    GetResourceWithBody.Params<L>,
    T | undefined
> {
    private requestResource: RequestResource<L, void, T>;

    constructor(http: Http) {
        super();
        this.requestResource = new RequestResource<L, void, T>(http);
    }

    protected debounceExecute(params: GetResourceWithBody.Params<L>): Promise<T | undefined> {
        return this.requestResource.execute({
            method: 'POST',
            parent: params.parent,
            rel: params.rel,
            search: params.search,
            noLinkError: params.noLinkError,
            queryParams: params.queryParams,
            body: params.body
        });
    }
}
